const CCP_API = {
  ccpProduct: "/CCP/BatchNO",
  CCP: "/CCP/CCP",
  images: "/CCP/Images",
  document: "/CCP/Document",
  comments: "/CCP/Comments",
  getListing: "/qcplisting",
  CCPs:"/CCP/CCPs",
  delete:"/CCP/CCP",
  deleteImage:"/CCP/Images",
  getStatus:"/CCP/Status"
};

export default CCP_API;
